import fetch from '@adc/fetch'
import configment from '@adc/configment'
import * as graph from '@adc/sdk'
import { gql } from '@adc/sdk'
import * as blueprint from '@adc/blueprint'
import { GRAPH_USER_DETAILS } from '../queries/getUserDetails'
import { FEATURE_FLAGS_FRAGMENT } from './featureFlags'

const userDetailsTransformer = user => ({
  logged_in: true,
  account_confirm: user.status === graph.enums.UserStatus.Confirmed,
  email_address: user.email,
  phone: (user.party?.phones || [])[0]?.number || '',
  ...user,
})

export const fetchGraphUserDetails = async (
  req,
  { shouldFetchAdaptiveNav = false } = {}
) => {
  const res = await fetch.forAuctionGraph(
    {
      query: GRAPH_USER_DETAILS,
      variables: {
        shouldFetchAdaptiveNav,
      },
    },
    { req }
  )

  const user = res.body.data.current_user

  return !user ? { logged_in: false } : userDetailsTransformer(user)
}

/**
 * Primarily for client-side "resend confirmation email" CTA's
 * @param  {string} email User's email address
 * @return {Object}      Promise to execute fetch
 */
export const resendConfirmationEmail = (req, email) =>
  fetch
    .forAuctionGraph({
      query: gql`
        mutation resiPdp_resendConfirmationEmail($email: String!) {
          resendConfirmationEmail(email: $email)
        }
      `,
      variables: { email },
    })
    .then(({ body }) => {
      if (body.errors) {
        throw new Error('Unable to resend confirmation email')
      }

      return body.data.resendConfirmationEmail
    })

export const fetchIdentityVerificationStatus = req =>
  fetch(
    `${configment.get('RESI_MS_PROFILE')}/resi/profile/v1/id-verification/`,
    {
      req,
    }
  ).then(req => req.body)

export const fetchDataForNewlyAuthenticatedUser = (
  listingId,
  isRemoteBiddingEnabled,
  context
) =>
  fetch
    .forAuctionGraph({
      /* eslint-disable @adc/named-gql-operations */
      query: gql`
        ${blueprint.listing.fragments.requiringActiveSession.definition}
        ${FEATURE_FLAGS_FRAGMENT}
        query resiPdp_fetchDataForNewlyAuthenticatedUser(
          $listingId: ID!
          $isRemoteBiddingEnabled: Boolean!
          $context: JSONObject
        ) {
          listing(listingId: $listingId) {
            ${blueprint.listing.fragments.requiringActiveSession.reference}
          }
          current_user {
            ...FeatureFlags
          }
        }
      `,
      variables: { listingId, isRemoteBiddingEnabled, context },
    })
    .then(res => res.body.data)
